import React, { Fragment } from 'react';
export function Hero() {
  return <div id="inicio" className="relative flex flex-col md:flex-row" style={{
    minHeight: 'min(100vh, 820px)'
  }} data-id="element-101">
      {/* Left: Text Content */}
      <div className="relative z-10 flex flex-col justify-center w-full md:w-[52%] bg-pitch py-24 md:py-0" data-id="element-102">
        <div className="max-w-lg mx-auto w-full px-8 md:px-10 lg:px-16" data-id="element-103">
          <p className="text-[9px] uppercase tracking-[0.3em] text-fire font-semibold mb-6" data-id="element-104">
            — Servicio a domicilio · Quito, Ecuador
          </p>

          <h1 className="font-heading text-ink leading-[1.02] mb-6" data-id="element-105">
            <span className="block text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight" data-id="element-106">
              La Mejor
            </span>
            <span className="block text-4xl md:text-5xl lg:text-6xl font-bold italic text-fire" data-id="element-107">
              Carne,
            </span>
            <span className="block text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight" data-id="element-108">
              A Tu Puerta.
            </span>
          </h1>

          <p className="text-muted text-sm md:text-base font-light leading-relaxed mb-10" data-id="element-109">
            Cortes premium certificados, entregados a domicilio en Quito. Vive
            la experiencia de la parrilla perfecta sin salir de casa.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-12" data-id="element-110">
            <button onClick={() => document.getElementById('catalogo')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-7 py-3.5 bg-fire text-white text-[10px] uppercase tracking-[0.15em] font-semibold hover:bg-ember transition-colors" data-id="element-111">
              Ver Catálogo
            </button>
            <button onClick={() => document.getElementById('packs')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-7 py-3.5 border border-ink/20 text-ink text-[10px] uppercase tracking-[0.15em] font-medium hover:border-ink/50 transition-colors" data-id="element-112">
              Nuestros Packs
            </button>
          </div>

          <div className="flex gap-8 border-t border-ink/10 pt-6" data-id="element-113">
            {[{
            value: '100%',
            label: 'Certificado'
          }, {
            value: '2h',
            label: 'Entrega'
          }, {
            value: 'DMQ',
            label: 'Quito'
          }].map((stat, i) => <Fragment key={stat.label} data-id="element-114">
                {i > 0 && <div className="w-px bg-ink/10 self-stretch" data-id="element-115" />}
                <div data-id="element-116">
                  <p className="text-xl font-heading font-bold text-ink" data-id="element-117">
                    {stat.value}
                  </p>
                  <p className="text-[9px] uppercase tracking-[0.15em] text-muted mt-0.5" data-id="element-118">
                    {stat.label}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="hidden md:block absolute left-[52%] top-0 bottom-0 w-px bg-fire/20 z-20" data-id="element-119" />

      {/* Right: Raw meat image */}
      <div className="relative w-full md:w-[48%] h-64 sm:h-80 md:h-auto flex-shrink-0 overflow-hidden" data-id="element-120">
        <img src="https://images.unsplash.com/photo-1603048297172-c92544798d5e?auto=format&fit=crop&q=80&w=1400" alt="Corte premium de carne cruda" className="w-full h-full object-cover" style={{
        position: 'absolute',
        inset: 0
      }} data-id="element-121" />
        <div className="absolute inset-0 bg-gradient-to-r from-pitch/20 via-transparent to-transparent" data-id="element-122" />
      </div>
    </div>;
}